export default __webpack_public_path__ + "67dd940afc0bbe9d28b54bac20792863.jpg";